import { useEffect, useRef, useState } from "react";
import { Bird } from "lucide-react";
import { DAWN_CHORUS } from "../data/content";

export default function AmbientAudio() {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem("jamoon-dawn-chorus") === "on";
    if (saved && audioRef.current) {
      audioRef.current.volume = 0.35;
      audioRef.current.play().then(() => setPlaying(true)).catch(() => setPlaying(false));
    }
  }, []);

  const toggle = () => {
    const a = audioRef.current;
    if (!a) return;
    if (playing) {
      a.pause();
      setPlaying(false);
      localStorage.setItem("jamoon-dawn-chorus", "off");
    } else {
      a.volume = 0.35;
      a.play().then(() => {
        setPlaying(true);
        localStorage.setItem("jamoon-dawn-chorus", "on");
      }).catch(() => {});
    }
  };

  return (
    <>
      <audio ref={audioRef} loop preload="none" data-testid="dawn-chorus-audio">
        <source src={DAWN_CHORUS.mp3} type="audio/mpeg" />
        <source src={DAWN_CHORUS.ogg} type="audio/ogg" />
      </audio>
      <button
        data-testid="dawn-chorus-toggle-btn"
        onClick={toggle}
        aria-label={playing ? "Stop the dawn chorus" : "Play the dawn chorus"}
        aria-pressed={playing}
        className={`fixed bottom-[4.5rem] right-4 z-40 flex items-center justify-center gap-2.5 rounded-full border p-3 text-[10px] font-medium tracking-[0.25em] backdrop-blur-md transition-colors duration-300 md:bottom-8 md:right-8 md:rounded-none md:px-4 md:py-2.5 ${
          playing
            ? "border-brass bg-brass/15 text-brass"
            : "border-ivory/25 bg-charcoal/70 text-ivory/80 hover:border-brass hover:text-brass"
        }`}
      >
        <Bird className={`h-4 w-4 ${playing ? "animate-pulse" : ""}`} />
        <span className="hidden md:inline">{playing ? "DAWN CHORUS ON" : "DAWN CHORUS"}</span>
      </button>
    </>
  );
}
